import { Provider } from 'react-easyrocket';
import { createSearchParams, useNavigate } from 'react-router';
import { STORAGE_URL } from 'src/api';
import { useDrawer } from 'src/hooks/useDrawer';
import providerDefault from 'src/assets/images/providerDefault.svg';
import { useRoute } from 'src/router/hooks';

interface ProviderButtonProps {
  provider: Provider;
  onClick?: () => void;
}

export const ProviderButton = ({
  provider: { name, providerIcon, gamesCount, id },
  onClick
}: ProviderButtonProps) => {
  const navigate = useNavigate();
  const { ROUTE } = useRoute();

  const { closeDrawer } = useDrawer();

  const handleClick = () => {
    navigate({
      pathname: ROUTE.GAMES.get(''),
      search: createSearchParams({ providerId: id.toString() }).toString()
    });
  };

  return (
    <div
      onClick={() => {
        handleClick();
        closeDrawer();
        onClick?.();
      }}
      className="flex flex-row items-center justify-between px-[6px] py-[10px] rounded-md w-full h-[34px] cursor-pointer gap-2 bg-p_card_bg provider-card">
      <div className="flex justify-start items-center gap-2">
        <img
          src={STORAGE_URL + providerIcon}
          className="h-[14px] w-auto"
          alt={name}
          onError={(event) => {
            const element = event.target as HTMLImageElement;
            element.src = providerDefault;
            element.onerror = null;
          }}
        />
        <p className="text-[14px]">{name}</p>
      </div>
      <p className="provider-amount text-p_games_count text-[14px]">{gamesCount}</p>
    </div>
  );
};
